import React from 'react';
import {Header} from './Header';
import {Footer} from './Footer';

import '../../../css/Header.css';
import '../../../css/Footer.css';
import '../../../css/Media.css';

export default ({children}) => (
    <div>
        <Header />
        {children}
        <Footer />
    </div>
);


// WEBPACK FOOTER //
// ./src/commons/ui/components/AppTemplate.js